import { useEffect, useState } from 'react';

import { getDeclinedOfferReason } from '../api/getDeclinedOfferReason';
import { DeclineReasons } from '../pages/StatusPage/DeclinedPage/StatusDeclinedPage';
import { useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';
/**
 * Runs the service for get declined offer reason
 * @returns a list of strings with reason for being declined
 */

const useGetDeclinedOfferReason = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();
    const [reason, setReason] = useState<DeclineReasons>(['OTHER']);

    useEffect(() => {
        if (!applicationReferenceNumber) {
            return;
        }
        getDeclinedOfferReason(proxyBaseUrl, apiKey, applicationReferenceNumber, authenticationData)
            .then((reason) => {
                setReason(reason);
            })
            .catch(() => {
                'error';
            });
    }, [applicationReferenceNumber]);

    return { reason };
};
export default useGetDeclinedOfferReason;
